import { render, staticRenderFns } from "./UserOnlineSocketBody.vue?vue&type=template&id=6ff360b7&"
import script from "./UserOnlineSocketBody.vue?vue&type=script&lang=ts&"
export * from "./UserOnlineSocketBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports